import { useTranslations, getImagePathForSharedLibrary } from "@jugl-web/utils";

import { UserCardItem } from "@jugl-web/domain-resources/users/components/UserCardItem";
import { WITHOUT_CUSTOMER_ITEM_ID } from "@jugl-web/domain-resources/users/hooks/useCustomerListBox";
import avatar from "./assets/without-user.png";

export const WithoutCustomerCard = ({
  isSelected,
  onSelect,
}: {
  isSelected?: boolean;
  onSelect: (customerId: string) => void;
}) => {
  const { t } = useTranslations();

  return (
    <UserCardItem
      variant="customer"
      name={t({
        id: "customers.without-customer",
        defaultMessage: "Without Customer",
      })}
      subtitle={t({
        id: "customers.without-customer-subtitle",
        defaultMessage: "No customer assigned",
      })}
      isSelected={isSelected}
      id={WITHOUT_CUSTOMER_ITEM_ID}
      onSelect={onSelect}
      avatarUrl={getImagePathForSharedLibrary(avatar)}
      attributes={[]}
      selectVariant="checkbox"
      isExpandButtonVisible={false}
    />
  );
};
